const RupeesSymbol = ({ size=17, color="#3c3c43", ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size - 2}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M6 3h12"/>
        <path d="M6 8h12"/>
        <path d="m6 13 8.5 8"/>
        <path d="M6 13h3"/>
        <path d="M9 13c6.667 0 6.667-10 0-10"/>
    </svg>
);

export default RupeesSymbol;
